interface ForeignParkingRowProps {
    label: string;
    value: string;
}

export default function ForeignParkingRow({ label, value }: ForeignParkingRowProps) {
    return (
        <div className="flex w-full items-start gap-[calc(30*var(--vw-unit))]">
            <p className="min-w-0 flex-1 text-[calc(24*var(--vh-unit))] leading-[calc(26*var(--vh-unit))] font-medium tracking-[calc(-0.48*var(--vh-unit))] text-[color:var(--color-text-main01)]">
                {label}
            </p>
            <p className="min-w-0 flex-1 text-right text-[calc(24*var(--vh-unit))] leading-[calc(26*var(--vh-unit))] font-medium tracking-[calc(-0.48*var(--vh-unit))] text-[color:var(--color-text-main01)]">
                {value}
            </p>
        </div>
    );
}
